<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZtcMqM/tc-custom/9781467468107.jpg?1730409764860" alt="This image is the cover for the book The Wise Leader"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Wise Leader
      </h1>
      <p class="bookDescription body article font2">
        <b>Leading and mentoring begins with wisdom.</b><br/><br/> Though we are overwhelmed with information, we often struggle to find true wisdom. Yet those leading or mentoring others, whether in business or in spiritual life, must rely on wisdom’s guidance to lead with purpose and meaning. With decades of leadership experience in business, nonprofits, and Christian higher education, Uli Chi helps readers build this foundational virtue. <br/><br/> Looking to Scripture as well as art and literature, Chi illuminates the nature of wisdom as fundamentally relational and other-centered. In the context of leadership, biblical wisdom shows us the importance of wielding power with humility. Chi also provides a framework for the formation of character and vision in the lifelong journey of gaining wisdom. Full of substantive and practical reflections, <i>The Wise Leader</i> both forms young leaders and teaches experienced leaders how to pass on the torch meaningfully.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Uli Chi
      </h2>
      
      <p class="authorDescription body article"><BR /><B>Uli Chi</B>&#160;has spent his life practicing leadership in the intersection of for-profit and nonprofit businesses, the theological academy, and the local church. Uli serves as board chair of the Virginia Mason Franciscan Health System. He is vice chair and senior fellow at the De Pree Center and a fellow at the Center for Faithful Business at Seattle Pacific University. Uli serves on the faculty for Regent College&#39;s MA in leadership, theology, and society.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a31bc9ae